export default __webpack_public_path__ + "static/media/blueArrow.290f7636.svg";